import { MODAL_CLOSE, MODAL_OPEN } from '../actions/types';

export const initialState = {
  id: '',
  opened: false,
  props: undefined,
};

export const modals = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_CLOSE:
      return initialState;
    case MODAL_OPEN: {
      if (action.payload.id) {
        state.id = action.payload.id;
        state.props = action.payload.props;
        state.opened = true;
      }
      return state;
    }
    default:
      return state;
  }
};
